import { EnvironmentsService } from './services/enviroment.service';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DeeplinkComponent } from './modules/deeplink/deeplink.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { JwtModule } from '@auth0/angular-jwt';
import { Cookie } from 'ng2-cookies';
import { DeeplinkOpenComponent } from './modules/deeplink-open/deeplink-open.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SwapWifi6Component } from './modules/swap-wifi-6/swap-wifi.component';
import { SwapWifiSharedModuleModule } from './modules/swap-wifi-shared-module/swap-wifi-shared-module.module';
import { ClickOutsideModule } from 'ng-click-outside';
import { PullUpSwapWifiComponent } from './modules/pull-up-swap-wifi/pull-up-swap-wifi.component';
import { IntroduceWifi6Component } from './modules/introduce-wifi6/introduce-wifi6.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { DeleteAccountComponent } from './modules/delete-account/delete-account.component';
import { MatInputModule } from '@angular/material/input';
import { HealthComponent } from './modules/health/health.component';
import { LandingPageUtilitiesComponent } from './modules/landing-page-utilities/landing-page-utilities.component';
import { ListContractComponent } from './modules/list-contract/list-contract.component';
import { ResultPaymentComponent } from './modules/result-payment/result-payment.component';
import { VietQRComponent } from './modules/viet-qr/viet-qr.component';
import { CompareWifi6Component } from './modules/compare-wifi6/compare-wifi6.component';
import {LinkComponent} from "./modules/link/Link.component";
import {DeeplinkPreviewComponent} from "./modules/deeplink-preview/deeplink.component";
import {DeeplinkNewComponent} from "./modules/deeplink-new/deeplink.component";
import { SwapWifiComponent } from './modules/swap-wifi/swap-wifi.component';

@NgModule({
  declarations: [
    AppComponent,
    DeeplinkComponent,
    DeeplinkOpenComponent,
    SwapWifi6Component,
    SwapWifiComponent,
    PullUpSwapWifiComponent,
    IntroduceWifi6Component,
    DeleteAccountComponent,
    HealthComponent,
    LandingPageUtilitiesComponent,
    ListContractComponent,
    ResultPaymentComponent,
    VietQRComponent,
    CompareWifi6Component,
    LinkComponent,
    DeeplinkPreviewComponent,
    DeeplinkNewComponent
  ],
  imports: [
    BrowserModule,
    SlickCarouselModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,
    MatDatepickerModule,
    SwapWifiSharedModuleModule,
    ClickOutsideModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: (request) => {
          return Cookie.get('webkit_token');
        },
      },
    }),
  ],
  providers: [
    EnvironmentsService,
    //{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: (envService: EnvironmentsService) => () => envService.init(),
      deps: [EnvironmentsService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
